import { useState } from "react";

interface ShareButtonProps {
  title: string;
}

export default function ShareButton({ title }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);
  const [panelOpen, setPanelOpen] = useState(false);

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement("input");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setPanelOpen((v) => !v)}
        className="flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-share-line text-sm" />
        分享
      </button>

      {panelOpen ? (
        <div className="absolute right-0 top-11 z-30 w-56 rounded-lg border border-background-200 bg-background-50 p-3 animate-fade-in">
          <p className="text-[11px] leading-relaxed text-foreground-600">
            《{title}》分享演示，仅复制本站链接，不会向第三方平台发送内容。
          </p>
          <button
            type="button"
            onClick={copyLink}
            className="mt-2.5 flex w-full items-center justify-center gap-1.5 rounded-md bg-primary-600 px-3 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-primary-700 cursor-pointer"
          >
            <i className={`${copied ? "ri-check-line" : "ri-link"}`} />
            {copied ? "链接已复制" : "复制页面链接"}
          </button>
          <div className="mt-2 flex items-center gap-1.5">
            {["ri-weibo-line", "ri-wechat-line", "ri-message-3-line"].map((icon) => (
              <span
                key={icon}
                className="flex h-8 flex-1 items-center justify-center rounded-md bg-background-100 text-foreground-500"
              >
                <i className={`${icon} text-sm`} />
              </span>
            ))}
          </div>
          <p className="mt-2 text-[10px] text-foreground-500">社交分享为界面演示，暂未接入真实接口</p>
        </div>
      ) : null}
    </div>
  );
}